import styled from 'styled-components';

export const Page = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    inset: 0;

    background: ${({ theme }) => theme.surface.primary};
`;
